<template>
	<div class="rightMain">
		<template v-if="item.artcount" v-for="(item,index) in resultlist">
			<template v-if="item.ChildList">
				<div class="itemHeader">
					<h1>{{item.colName}}</h1>
				</div>
				<template v-for="(citem,cindex) in item.ChildList">
					<div class="item_title">
						<h1 v-if="citem.colID&&citem.artLst.length">{{citem.colName}}</h1>
						<h1 v-if="citem.tagId&&citem.artLst.length">{{citem.tagName}}</h1>
						<router-link v-if="citem.colID&&citem.artLst.length" :to="{ name: 'theme', params: { pagetype: '3', colid: citem.colID }, query: { col : sourcecol }}"  class="more" @click.native="$track([['pagetype','热点话题页-'+keyword+'-'+citem.colName+'-更多-点击']])">更多</router-link>
						<router-link v-if="citem.tagId&&citem.artLst.length" :to="{ name: 'theme', params: { pagetype: '4', colid: citem.tagId }, query: { col : sourcecol }}"  class="more" @click.native="$track([['pagetype','热点话题页-'+keyword+'-'+citem.tagName+'-更多-点击']])">更多</router-link>
					</div>
					<ul class="list5">
						<li v-for="(aitem,aindex) in citem.artLst">
								<router-link :to="{ name: 'detail', params: { id: aitem.id }, query: { the : '1' , col : sourcecol}}" v-html="aitem.titleTagName+aitem.articletitle+'<i></i>'" target="_blank" @click.native="$track([['pagetype','热点话题页-'+keyword+'-'+item.colName+'-'+(citem.colName?citem.colName:citem.tagName)+'-文章-id:'+aitem.id+'-点击']])" :title="aitem.articletitle"></router-link>
								<em>{{aitem.updateTime.substring(0,10)}}</em>
						</li>
					</ul>
				</template>
			</template>
			<template v-else>
				<div class="itemHeader">
					<h1>{{item.colName}}</h1>
					<router-link v-if="item.Type!='4'" :to="{ name: 'theme', params: { pagetype: '3', colid: item.colID }, query: { col : sourcecol }}"  class="more" @click.native="$track([['pagetype','热点话题页-'+keyword+'-'+item.colName+'-更多-点击']])">更多</router-link>
					<router-link v-else :to="{ name: 'theme', params: { pagetype: '4', colid: item.colID }, query: { col : sourcecol }}"  class="more" @click.native="$track([['pagetype','热点话题页-'+keyword+'-'+item.colName+'-更多-点击']])">更多</router-link>
				</div>
				<ul class="list5">
					<li v-for="(aitem,aindex) in item.artLst">
							<router-link :to="{ name: 'detail', params: { id: aitem.id }, query: { the : '1' , col : sourcecol}}" v-html="aitem.titleTagName+aitem.articletitle+'<i></i>'" target="_blank" @click.native="$track([['pagetype','热点话题页-'+keyword+'-'+item.colName+'-文章-id:'+aitem.id+'-点击']])" :title="aitem.articletitle"></router-link>
							<em>{{aitem.updateTime.substring(0,10)}}</em>
					</li>
				</ul>
			</template>
		</template>
	</div>
</template>

<script>
	export default{
		props:[
			'resultlist',
			'sourcecol',
			'keyword'
		]
	}
</script>

<style>
</style>
